var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDemographics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_600_22942)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_22942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3337 29.181C15.8358 29.3332 16.5141 29.3332 17.667 29.3332H26.3337C27.4866 29.3332 28.1648 29.3332 28.667 29.181M15.3337 29.181C15.226 29.1484 15.1264 29.1088 15.032 29.0607C14.5616 28.821 14.1792 28.4386 13.9395 27.9681C13.667 27.4334 13.667 26.7333 13.667 25.3332V16.6665C13.667 15.2664 13.667 14.5663 13.9395 14.0315C14.1792 13.5611 14.5616 13.1787 15.032 12.939C15.5668 12.6665 16.2669 12.6665 17.667 12.6665H26.3337C27.7338 12.6665 28.4339 12.6665 28.9686 12.939C29.439 13.1787 29.8215 13.5611 30.0612 14.0315C30.3337 14.5663 30.3337 15.2664 30.3337 16.6665V25.3332C30.3337 26.7333 30.3337 27.4334 30.0612 27.9681C29.8215 28.4386 29.439 28.821 28.9686 29.0607C28.8742 29.1088 28.7746 29.1484 28.667 29.181M15.3337 29.181C15.334 28.5066 15.338 28.1497 15.3977 27.8495C15.6607 26.5272 16.6944 25.4936 18.0167 25.2306C18.3387 25.1665 18.7259 25.1665 19.5003 25.1665H24.5003C25.2748 25.1665 25.662 25.1665 25.984 25.2306C27.3063 25.4936 28.3399 26.5272 28.6029 27.8495C28.6627 28.1497 28.6667 28.5066 28.667 29.181M25.3337 18.9165C25.3337 20.7575 23.8413 22.2498 22.0003 22.2498C20.1594 22.2498 18.667 20.7575 18.667 18.9165C18.667 17.0756 20.1594 15.5832 22.0003 15.5832C23.8413 15.5832 25.3337 17.0756 25.3337 18.9165Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_600_22942",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_600_22942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_600_22942",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_22942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemographics);
export default __webpack_public_path__ + "static/media/demographics.578e6312a1068fab7e3b051746e142be.svg";
export { ForwardRef as ReactComponent };